import Article from "../../components/Article/Article";
import ArticlePage from "../../components/Article/ArticlePage";
import api from "../../lib/api";

export default function Project({ projectPages, slug }) {
  return (
    <ArticlePage navData={projectPages} baseRoute="project">
      <Article data={projectPages.find((page) => page.slug === slug).article} />
    </ArticlePage>
  );
}

export async function getStaticPaths() {
  const projectPages = await api.getProjectPages("de");

  const pathsDe = projectPages.map((page) => ({
    params: { slug: page.slug },
    locale: "de",
  }));
  const pathsEn = projectPages.map((page) => ({
    params: { slug: page.slug },
    locale: "en",
  }));

  return { paths: [...pathsDe, ...pathsEn], fallback: "blocking" };
}

export async function getStaticProps({ params, locale }) {
  const slug = params.slug;
  const projectPages = await api.getProjectPages(locale);

  if (!projectPages.find((page) => page.slug === slug)) {
    return { notFound: true };
  }

  return await api.injectDefaultData(
    {
      props: { projectPages, slug },
      revalidate: 3,
    },
    locale,
  );
}
